import { LatLngTuple } from "leaflet";

export const centerMap: LatLngTuple = [22, 9.5];
